import {createAction, props} from '@ngrx/store';
import {Alert} from '@app/shared/models/alert.model';

export const fetchAlerts = createAction('[Notifications] Fetch Alerts');

export const fetchAlertsSuccess = createAction('[Notifications] Fetch Alerts Success', props<{response: Alert[]}>());
